import React, { FunctionComponent } from "react";

import { LoadingButton } from "@mui/lab";
import Button, { ButtonProps } from "@mui/material/Button";
import MuiPopover, { PopoverProps } from "@mui/material/Popover";
import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import { ELLIPSIS_SX } from "@app/common/styles";

import Stack, { Row, StackProps } from "@rui/Stack";

export const Popover = (props: PopoverProps) => (
  <MuiPopover
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: -8, horizontal: 0 }}
    {...props}
  />
);

export const PopoverHeader = styled(Row)(({ theme }) => ({
  paddingBottom: theme.spacing(0.5),
  borderBottom: `1px solid ${theme.palette.shades.neutral[50]}`,
}));

export const PopoverHeading = styled<FunctionComponent<TypographyProps>>(
  (props) => <Typography variant="bodySecondaryMed" {...props} />
)(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
}));

export const PopoverContent = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.5),
  width: "280px",
}));

export const HeaderButton = styled<FunctionComponent<ButtonProps>>((props) => (
  <Button variant="text" {...props} />
))({
  fontSize: "0.75rem",
  minWidth: "fit-content",
});

export const ActionButton = styled(LoadingButton)({
  borderRadius: "6px",
  flexBasis: "calc(50% - 4px)",
  height: "40px",
});

export const TextField = styled(Row)(({ theme }) => ({
  width: "100%",
  border: `1px solid ${theme.palette.shades.neutral[100]}`,
  borderRadius: "6px",
  padding: theme.spacing(0.5, 1),
  "&:focus-within": {
    borderColor: theme.palette.shades.primary[500],
  },
  "&:hover": {
    cursor: "text",
  },
  "& .MuiInputBase-input": {
    fontSize: "0.75rem",
    fontFamily: theme.typography.fontFamilySecondary,
    lineHeight: 16 / 12,
    padding: 0,
  },
  "& .MuiInput-root": {
    padding: 0,
  },
}));

export const AdornedTextField = styled(TextField)(({ theme }) => ({
  flexWrap: "wrap",
  columnGap: "4px",
  rowGap: "4px",
  padding: theme.spacing(0.5),
}));

export const TagListContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: "4px",
  border: `1px solid ${theme.palette.shades.neutral[100]}`,
}));

export const TagList = styled(Row)({
  flexWrap: "wrap",
  columnGap: "4px",
  rowGap: "4px",
});

export const SelectableTagContainer = styled<FunctionComponent<StackProps>>(
  (props) => <Row variant="apart" spacing={1} {...props} />
)(({ onClick, theme }) => ({
  overflow: "hidden",
  paddingBottom: "6px",
  "& .selectable-tag__label": {
    ...ELLIPSIS_SX,
    fontFamily: theme.typography.fontFamilySecondary,
    color: theme.palette.shades.neutral[800],
  },
  "&:hover": {
    cursor: onClick ? "pointer" : "default",
  },
}));
